import { put, call, takeEvery } from 'redux-saga/effects'
import { RestHelper } from '../helpers/RestHelper'
import * as ProfileActions from '../actions/ProfileActions'

const getProfileFromServer = function*(action: any) {
    try {
        // Make the REST request to the server to get the user's profile.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/profile`);

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: ProfileActions.GET_PROFILE_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: ProfileActions.GET_PROFILE_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: ProfileActions.GET_PROFILE_FAILED_ACTION_TYPE, message: e.message});
    }
}

const exportUserGdprReportFromServer = function*(action: ProfileActions.IExportUserGdprReportAction) {
    try {
        // Make the REST request to the server to log the user in.
        let response: Response = yield call(RestHelper.post, `${RestHelper.RootUrl}/sdk/users/v1.0/user/data/export`, "");

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: ProfileActions.EXPORT_USER_GDPR_REPORT_SUCCEEDED_ACTION_TYPE, json: json});
            yield put({type: ProfileActions.SET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: ProfileActions.EXPORT_USER_GDPR_REPORT_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: ProfileActions.EXPORT_USER_GDPR_REPORT_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserCanExportGdprReportFromServer = function*(action: ProfileActions.IGetUserCanExportGdprReportAction) {
    try {
        // Make the REST request to the server to get the user's profile.
        let response: Response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/data/export`);

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: ProfileActions.GET_USER_CAN_EXPORT_GDPR_REPORT_SUCCEEDED_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: ProfileActions.GET_USER_CAN_EXPORT_GDPR_REPORT_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: ProfileActions.GET_USER_CAN_EXPORT_GDPR_REPORT_FAILED_ACTION_TYPE, message: e.message});
    }
}

const requestUserYearInReviewReportFromServer = function*(action: ProfileActions.IRequestUserYearInReviewReportAction) {
    try {
        // Make the REST request to the server to e-mail the report.
        let response: Response = yield call(RestHelper.post, `${RestHelper.RootUrl}/sdk/users/v1.0/user/data/yearinreview/email/${action.year}`, "");

        if (response.ok)
        {
            let json:string = yield response.json();
            yield put({type: ProfileActions.REQUEST_USER_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE, json: json});
            yield put({type: ProfileActions.SET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE, json: json});
        }
        else
        {
            yield put({type: ProfileActions.REQUEST_USER_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response.status});
        }
    }
    catch (e: any) {
        yield put({type: ProfileActions.REQUEST_USER_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE, message: e.message});
    }
}

const getUserCanRequestYearInReviewReportFromServer = function*(action: ProfileActions.IGetUserCanRequestYearInReviewReportAction) {
    try {
        let response: Response | null = null;
        let json: string | null = null;

        // Make the REST request to the server to get the user's profile.
        let acceptedYears: number[] = [];
        for (let i = 0; i < action.years.length; i++) {
            response = yield call(RestHelper.get, `${RestHelper.RootUrl}/sdk/users/v1.0/user/data/yearinreview/hasreport/${action.years[i]}`);

            if (response?.ok)
            {
                json = yield response.json();
                if ((json as any).exists) {
                    acceptedYears.push(action.years[i]);
                }
            }
        }
              
        if (acceptedYears.length > 0) {
            yield put({type: ProfileActions.GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE, json: json, acceptedYears: acceptedYears});
        }
        else {
            yield put({type: ProfileActions.GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE, message: 'Request failed with status code: ' + response?.status});
        }
    }
    catch (e: any) {
        yield put({type: ProfileActions.GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE, message: e.message});
    }
}

export const getProfileFromServerSaga = function*() {
    yield takeEvery(ProfileActions.GET_PROFILE_ACTION_TYPE, getProfileFromServer);
}

export const exportUserGdprToServerSaga = function*() {
    yield takeEvery(ProfileActions.EXPORT_USER_GDPR_REPORT_ACTION_TYPE, exportUserGdprReportFromServer);
}

export const getUserCanExportGdprReportFromServerSaga = function*() {
    yield takeEvery(ProfileActions.GET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE, getUserCanExportGdprReportFromServer);
}

export const requestUserYearInReviewReportToServerSaga = function*() {
    yield takeEvery(ProfileActions.REQUEST_USER_YEAR_IN_REVIEW_REPORT_ACTION_TYPE, requestUserYearInReviewReportFromServer);
}

export const getUserCanRequestYearInReviewReportFromServerSaga = function*() {
    yield takeEvery(ProfileActions.GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE, getUserCanRequestYearInReviewReportFromServer);
}